import { QueryFunctionContext, useQuery } from "@tanstack/react-query";
import { configuration } from "src/configuration";
import { FetchError, GetFeedDto, queryKeys, useAccessToken } from "src/http";

const useGetTaskItemFeedRequest = () => {
  const { getAccessToken } = useAccessToken();

  async function getTaskItemFeedRequest({
    queryKey,
  }: QueryFunctionContext<ReturnType<typeof queryKeys.taskItems.getTaskItemFeed>>): Promise<GetFeedDto> {
    const accessToken = await getAccessToken();
    const [{ taskItemGuid }] = queryKey;

    const response = await fetch(`${configuration.apiRootUrl}/task-items/${taskItemGuid}/feed`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return { getTaskItemFeedRequest };
};

const useGetTaskItemFeed = (taskItemGuid: string) => {
  const { getTaskItemFeedRequest } = useGetTaskItemFeedRequest();

  return useQuery({
    queryKey: queryKeys.taskItems.getTaskItemFeed(taskItemGuid),
    queryFn: getTaskItemFeedRequest,
  });
};

export { useGetTaskItemFeed };
